import React from 'react'
import Grid from '@mui/material/Grid2'
import RegularButton from '@/components/buttons/RegularButton'
import Image from '@/components/image/Image'
import Divider from '@/components/divider/Divider'
import Carousel from '@/components/carousel/Carousel'
import { useNavigate } from 'react-router-dom'

const carouselImages = [
  '/images/statics/cleaning.jpg',
  '/images/statics/fika-3.jpg',
  '/images/statics/recording.jpg',
  '/images/history/ostersjofestivalen-4.jpg',
]

const GallerySelector: React.FC = () => {
  const navigate = useNavigate()
  return (
    <Grid
      container
      direction="row"
      spacing={2}
      justifyContent="center"
      alignItems="flex-start"
      textAlign="center"
    >
      <Grid size={10}>
        <h1>Bild- & filmarkiv</h1>
      </Grid>

      <Grid size={{ xs: 11, md: 3 }}>
        <Grid size={12}>
          <Image
            src="/images/statics/recording.jpg"
            alt="Inspelning"
            height="250px"
            width="350px"
          />
        </Grid>
        <Grid size={12}>
          <h2>Videos</h2>
          <p>Videos, inspelning, repotage mm</p>
        </Grid>
        <Grid size={12}>
          <RegularButton
            label="Läs mer"
            onClick={() => navigate('/video-gallery?selector=all')}
          />
        </Grid>
      </Grid>

      {/* <Grid size={{ xs: 11, md: 3 }}>
        <Grid size={12}>
          <Image src='/images/events/kulturnatten-2024.jpg' alt="Kulturnatten" />
        </Grid>
        <Grid size={12}>
          <h2>2020-2024</h2>
          <p>Senaste åren</p>
        </Grid>
        <Grid size={12}>
          <RegularButton
            label='Läs mer'
            onClick={() => navigate('/image-gallery?selector=2020-2024')}
          />
        </Grid>
      </Grid> */}

      <Grid size={{ xs: 11, md: 3 }}>
        <Grid size={12}>
          <Image
            src="/images/statics/poster-image.jpg"
            alt="Poster"
            height="250px"
            width="350px"
          />
        </Grid>
        <Grid size={12}>
          <h2>Affisher</h2>
          <p>Affisher genom tiderna</p>
        </Grid>
        <Grid size={12}>
          <RegularButton
            label="Läs mer"
            onClick={() => navigate('/image-gallery?selector=posters')}
          />
        </Grid>
      </Grid>

      <Divider size={{ xs: 11, md: 10 }} />

      <Grid size={{ xs: 11, md: 10 }} sx={{ marginTop: '50px' }}>
        <Image src="/images/statics/groupimage-2024.jpg" alt="Gruppbild" />
        <h3>Nuvarande uppsättning - 2024</h3>
      </Grid>

      <Grid sx={{ marginBottom: '50px' }}>
        <Carousel images={carouselImages} />
      </Grid>
    </Grid>
  )
}

export default GallerySelector
